module.exports = __webpack_public_path__ + "20f4a6d3275f9f04d521c64fb33d88a8.svg";